module.exports = {"id":"193469","name":"Víctor Ruíz","rating":"82","photo":"./data/images/photos/1/193469.png","club":{"name":"Villarreal CF","logo":"./data/images/clubs/VillarrealCF.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VictorRuiz0.json
// module id = 4257
// module chunks = 0